import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-number-input',
    templateUrl: './number-input.component.html',
    styleUrls: ['./number-input.component.scss']
})
export class NumberInputComponent implements OnInit {

    @Input() value: any;
    @Output() valueChange = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit(): void {
    }


    onWeightChange(value: any) {
        const str = String(value ?? '');
        const sanitized = str.replace(/,/g, '.').replace(/^\-+/, '');
        const num = sanitized === '' ? null : Number(sanitized);
        const newValue = Number.isFinite(num as number) ? num : null;
        this.value = newValue;
        this.valueChange.emit(newValue);
    }
}
